import { render, staticRenderFns } from "./ReportCardEditor.vue?vue&type=template&id=f8d556be&scoped=true"
import script from "./ReportCardEditor.vue?vue&type=script&lang=js"
export * from "./ReportCardEditor.vue?vue&type=script&lang=js"
import style0 from "./ReportCardEditor.vue?vue&type=style&index=0&id=f8d556be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d556be",
  null
  
)

export default component.exports